export enum TipoEnvio {
  PORTAL = 0,
  EMAIL = 1,
  AMBOS = 2
}

export const TipoEnvioLabels = {
  [TipoEnvio.PORTAL]: 'comunicado.lista.portal',
  [TipoEnvio.EMAIL]: 'comunicado.lista.email',
  [TipoEnvio.AMBOS]: 'comunicado.lista.ambos'
};

export const TipoEnvioIcons = {
  [TipoEnvio.PORTAL]: 'fas fa-globe',
  [TipoEnvio.EMAIL]: 'fas fa-envelope',
  [TipoEnvio.AMBOS]: 'fas fa-broadcast-tower'
};

export const TipoEnvioClasses = {
  [TipoEnvio.PORTAL]: 'portal-badge',
  [TipoEnvio.EMAIL]: 'email-badge',
  [TipoEnvio.AMBOS]: 'ambos-badge'
};
